/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starting_Event_IdInputs */

const en_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting Event Id`)
};

const fr_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d’événement de départ`)
};

const de_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startereignis-ID`)
};

const it_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID evento iniziale`)
};

const ru_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор начального события`)
};

const es_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id. de evento inicial`)
};

const zh_cn2_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起始事件 ID`)
};

const ja_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始イベントID`)
};

const hi_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ घटना आईडी`)
};

const pt_pt2_starting_event_id = /** @type {(inputs: Starting_Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do evento inicial`)
};

/**
* | output |
* | --- |
* | "Starting Event Id" |
*
* @param {Starting_Event_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const starting_event_id = /** @type {((inputs?: Starting_Event_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starting_Event_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_starting_event_id(inputs)
	if (locale === "de") return de_starting_event_id(inputs)
	if (locale === "it") return it_starting_event_id(inputs)
	if (locale === "ru") return ru_starting_event_id(inputs)
	if (locale === "es") return es_starting_event_id(inputs)
	if (locale === "zh-CN") return zh_cn2_starting_event_id(inputs)
	if (locale === "ja") return ja_starting_event_id(inputs)
	if (locale === "hi") return hi_starting_event_id(inputs)
	if (locale === "pt-PT") return pt_pt2_starting_event_id(inputs)
	return en_starting_event_id(inputs)
});